package com.example.mystybag.login.logic

import com.example.mystybag.common.logic.NavigatorMerchantLogin
import com.example.mystybag.common.resources.SR
import com.example.mystybag.core.expected.sharedString
import com.example.mystybag.core.logic.base.AppContext
import com.example.mystybag.core.logic.base.ChildViewModel
import com.example.mystybag.login.model.MerchantRegistrationSuccessUIState

class MerchantRegistrationSuccessViewModel(
    context: AppContext
) : ChildViewModel<MerchantRegistrationSuccessUIState>(context, MerchantRegistrationSuccessUIState()) {

    override fun onCreate() {
        navControls.backButtonVisible = false // Don't allow going back from success screen
    }

    fun onProceedToLogin() {
        navigate(NavigatorMerchantLogin)
    }
}
